import { createSlice } from "@reduxjs/toolkit";
import { forgotPassword, resetPassword } from "../utils/Apis";

const initialState = {
  isAuthenticated: !!localStorage.getItem("token"), // Boolean value
  role: localStorage.getItem("role") || null,
  token: localStorage.getItem("token") || null,

  // Forgot Password State
  forgotPasswordLoading: false,
  forgotPasswordMessage: null,
  forgotPasswordError: null,

  // Reset Password State
  resetPasswordLoading: false,
  resetPasswordMessage: null,
  resetPasswordError: null,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setUser: (state, action) => {
      state.isAuthenticated = true;
      state.role = action.payload.role;
      state.token = action.payload.token;

      localStorage.setItem("token", state.token);
      localStorage.setItem("role", state.role);
    },
    logout: (state) => {
      state.isAuthenticated = false;
      state.role = null;
      state.token = null;

      // Clear all authentication-related data
      localStorage.removeItem("token");
      localStorage.removeItem("role");
    },
    clearForgotPasswordState: (state) => {
      state.forgotPasswordLoading = false;
      state.forgotPasswordMessage = null;
      state.forgotPasswordError = null;
    },
    clearResetPasswordState: (state) => {
      state.resetPasswordLoading = false;
      state.resetPasswordMessage = null;
      state.resetPasswordError = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(forgotPassword.pending, (state) => {
        state.forgotPasswordLoading = true;
        state.forgotPasswordMessage = null;
        state.forgotPasswordError = null;
      })
      .addCase(forgotPassword.fulfilled, (state, action) => {
        state.forgotPasswordLoading = false;
        state.forgotPasswordMessage = action.payload.msg;
      })
      .addCase(forgotPassword.rejected, (state, action) => {
        state.forgotPasswordLoading = false;
        state.forgotPasswordError = action.payload || "Something went wrong";
      })
      // ===== Reset Password =====
      .addCase(resetPassword.pending, (state) => {
        state.resetPasswordLoading = true;
        state.resetPasswordMessage = null;
        state.resetPasswordError = null;
      })
      .addCase(resetPassword.fulfilled, (state, action) => {
        state.resetPasswordLoading = false;
        state.resetPasswordMessage = action.payload.msg;
      })
      .addCase(resetPassword.rejected, (state, action) => {
        state.resetPasswordLoading = false;
        state.resetPasswordError = action.payload || "Something went wrong";
      });
  },
});

export const { setUser, logout } = authSlice.actions;

// Selectors to access state values in components
export const selectIsAuthenticated = (state) => state.auth.isAuthenticated;
export const selectRole = (state) => state.auth.role;

export const selectForgotPasswordState = (state) => ({
  loading: state.auth.forgotPasswordLoading,
  message: state.auth.forgotPasswordMessage,
  error: state.auth.forgotPasswordError,
});
export const selectResetPasswordState = (state) => ({
  loading: state.auth.resetPasswordLoading,
  message: state.auth.resetPasswordMessage,
  error: state.auth.resetPasswordError,
});

export default authSlice.reducer;
